/**
 * Adds where the user was headed to the provider's url, so the sign-in callback
 * can put them back there.
 *
 * Only a relative destination is passed on. An absolute one would let a crafted
 * sign-in link bounce somebody to another origin carrying a fresh session --
 * which is the same open-redirect the backend guards its own `original` handling
 * against, and it has to hold on both sides.
 */
export function signInUrl(redirectUrl: string, original?: string): string {
  if (original === undefined || original === '' || !isRelativeUrl(original)) {
    return redirectUrl
  }
  const url = new URL(redirectUrl)
  url.searchParams.append('original', original)
  return url.toString()
}

export function isRelativeUrl(url: string): boolean {
  return !/^(?:[a-z+]+:)?\/\//i.test(url)
}
